import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { responsiveCssProperties } from '../../utils';
import { Box } from '../Box';
import './Stack.css';
/**
 * Stack your components vertically and apply consistent spacing between them.
 *
 * Inherits all properties from the `<Box>` component.
 */
export const Stack = forwardRef(function Stack(props, ref) {
    const { children, className, elementType = 'div', spacing, ...rest } = props;
    return (React.createElement(Box, { ...rest, elementType: elementType, className: clsx('mollie-ui-stack', className), ref: ref },
        React.createElement("div", { className: clsx('mollie-ui-stack-content'), style: responsiveCssProperties('--mollie-ui-stack-spacing', spacing) }, children)));
});
Stack.displayName = 'Stack';
//# sourceMappingURL=Stack.js.map